<template>
  <nav
    class="bottom-navbar d-flex align-items-center justify-content-around bg-white shadow-lg"
    role="navigation"
    aria-label="Navigation principale mobile"
  >
    <router-link
      v-for="(url, index) in listeUrl"
      :key="index"
      :to="{ name: url.name }"
      :aria-label="url.text"
      :aria-current="
        $route.name === url.name ||
        ($route.name === 'details-categorie' && url.name === 'categories')
          ? 'page'
          : undefined
      "
      class="nav-item d-flex flex-column align-items-center text-decoration-none rounded-3 transition-all"
      :class="{
        'active-mobile-link': $route.name === 'details-categorie' && url.name === 'categories'
      }"
      activeClass="active-mobile-link"
    >
      <font-awesome-icon
        :icon="`fa-solid fa-${url.icon}`"
        class="nav-icon-mobile mb-1"
        size="lg"
        aria-hidden="true"
      />
      <span class="nav-text-mobile">{{ url.shortText || url.text }}</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'BottomNavBar',

  data() {
    return {
      listeUrl: [
        {
          name: 'home',
          text: 'Tableau de bord',
          shortText: 'Accueil',
          icon: 'chart-line'
        },
        {
          name: 'categories',
          text: 'Catégories',
          shortText: 'Catégories',
          icon: 'tags'
        },
        {
          name: 'recurrences',
          text: 'Récurrences',
          shortText: 'Récurrences',
          icon: 'rotate'
        },
        {
          name: 'compte',
          text: 'Compte',
          shortText: 'Compte',
          icon: 'user'
        }
      ]
    }
  }
}
</script>
